// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "-" + {"74":"a8b8b64b","615":"8e45e48e","618":"2c821b18","870":"e23086c0"}[chunkId] + ".css";
};